<template>
  <main-layout>
    <form-layout>
      <el-form
        v-if="form"
        :model="form"
        :rules="rules"
        label-width="150px"
        ref="form"
      >
        <el-form-item
          :error="errors.businessScopes"
          :label="$t('business_scopes')"
          prop="businessScopes"
        >
          <sector-selector
            :max-l1="3"
            :sectors="$store.state.app.configs.sectors"
            v-model="form.businessScopes"
          ></sector-selector>
        </el-form-item>
        <el-form-item
          :error="errors.businessModels"
          :label="$t('business_model')"
          prop="businessModelneas"
        >
          <el-checkbox-group v-model="form.businessModels">
            <el-checkbox
              :key="item"
              :label="item"
              v-for="item in $store.state.app.configs.businessModels"
              >{{ $t(`business_model_${item}`) }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          :error="errors.marketInterests"
          :label="$t('market_interests')"
          prop="marketInterests"
        >
          <el-checkbox-group :max="3" :min="1" v-model="form.marketInterests">
            <el-checkbox
              :key="item"
              :label="item"
              v-for="item in Object.keys($store.state.app.configs.sectors)"
              >{{ $t(`sector_${item}`) }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          :error="errors.coModels"
          :label="$t('co_model')"
          prop="coModels"
        >
          <el-checkbox-group :max="3" :min="1" v-model="form.coModels">
            <el-checkbox
              :key="item"
              :label="item"
              v-for="item in $store.state.app.configs.coModels"
              >{{ $t(`co_model_${item}`) }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          :error="errors.nearTermCapitalRisingPlan"
          :label="$t('near_term_capital_rising_plan')"
          prop="nearTermCapitalRisingPlan"
        >
          <el-radio-group v-model="form.nearTermCapitalRisingPlan">
            <el-radio
              :key="item"
              :label="item"
              v-for="item in $store.state.app.configs
                .nearTermCapitalRisingPlanOptions"
              >{{ $t(`option_${item}`) }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item
          :error="errors.advantages"
          :label="$t('company_advantages')"
          prop="advantages"
        >
          <el-input
            :placeholder="$t('company_advantages_placeholder')"
            :rows="3"
            type="textarea"
            v-model="form.advantages"
          ></el-input>
        </el-form-item>
        <el-form-item
          :error="errors.customerType"
          :label="$t('customer_type')"
          prop="customerType"
        >
          <el-input
            :placeholder="$t('customer_types_placeholder')"
            v-model="form.customerType"
          ></el-input>
        </el-form-item>
        <el-form-item
          :error="errors.patents"
          :label="$t('patents')"
          prop="patents"
        >
          <el-input
            :placeholder="$t('patents_placeholder')"
            :rows="3"
            type="textarea"
            v-model="form.patents"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('tags')" prop="tags" :error="errors.tags">
          <dynamic-tags
            v-model="form.tags"
            :new-tag-label="$t('new_tag')"
          ></dynamic-tags>
        </el-form-item>
      </el-form>
      <div slot="bottom-bar">
        <el-button @click="previous" slot="footer" type="primary">
          {{ $t('previous') }}
        </el-button>
        <el-button @click="submit" slot="footer" type="primary">
          {{ $t('next') }}
        </el-button>
      </div>
    </form-layout>
  </main-layout>
</template>

<script>
import { lengthValidator } from '@/utils/validators';
import MainLayout from '@/components/layout/main';
import FormLayout from '@/components/layout/form';
import SectorSelector from '@/components/public/sector-selector';
import DynamicTags from '@/components/public/dynamic-tags';

export default {
  name: 'Company',
  components: {
    MainLayout,
    FormLayout,
    SectorSelector,
    DynamicTags,
  },
  props: {},
  data() {
    return {
      form: null,
      emptyForm: {
        businessScopes: [],
        businessModels: [],
        marketInterests: [],
        coModels: [],
        nearTermCapitalRisingPlan: '',
        advantages: '',
        customerType: '',
        patents: '',
        tags: []
      },
      errors: {
        listingAttribute: null,
        businessScopes: null,
        businessModels: null,
        marketInterests: null,
        coModels: null,
        nearTermCapitalRisingPlan: null,
        advantages: null,
        customerType: null,
        patents: null,
        tags: null
      },
      loadingCount: 0,
    };
  },
  computed: {
    rules() {
      return {
        listingAttribute: [
          {
            required: true,
          },
        ],
        businessScopes: [
          {
            required: true,
          },
        ],
        businessModels: [],
        marketInterests: [
          {
            required: true,
          },
          {
            validator: lengthValidator,
            min: 1,
            max: 3,
            trigger: 'change',
          },
        ],
        coModels: [
          {
            required: true,
          },
          {
            validator: lengthValidator,
            min: 1,
            max: 5,
            trigger: 'change',
          },
        ],
        nearTermCapitalRisingPlan: [
          {
            required: true,
          },
        ],
        advantages: [
          {
            validator: lengthValidator,
            min: 1,
            max: 300,
            trigger: 'change',
          },
        ],
        customerType: [
          {
            required: true,
          },
        ],
        patents: [
          {
            validator: lengthValidator,
            min: 1,
            max: 100,
            trigger: 'change',
          },
        ],
      };
    },
  },
  watch: {},
  methods: {
    setErrors(errors) {
      if (errors) {
        for (let i = 0; i < errors.length; i++) {
          let error = errors[i];
          if (typeof error === 'string') {
            error = {
              name: error,
              error: ['error'],
            };
          }
          const [text, values] = error.error || [error.message, []];
          this.errors[error.path] = this.$t(text, values || undefined);
        }
      }
    },
    resetErrors() {
      Object.keys(this.errors).forEach(value => {
        if (this.errors[value] instanceof Array) {
          this.errors[value] = this.errors[value].map(() => null);
        } else {
          this.errors[value] = null;
        }
      });
    },
    submit() {
      this.resetErrors();
      this.$refs.form.validate(formValid => {
        if (formValid) {
          this.$store.commit('selfUpload/setBusinessFocus', this.form);
          this.next();
        } else {
          this.$notify.error({
            title: this.$t('operation_failed'),
            message: this.$t('validation_failed'),
          });
        }
        return formValid;
      });
    },
    next() {
      this.$router.push('/contacts');
    },
    previous() {
      this.$router.push('/company-profile');
    },
  },
  created() {
    const form = Object.assign({}, this.emptyForm);
    if (this.$store.state.selfUpload.businessFocus) {
      Object.assign(form, this.$store.state.selfUpload.businessFocus);
    }
    this.form = form;
  },
};
</script>
